export const PERCENTAGE_TYPE = [
    { name: 'INCREASE', label: 'INCREASE', value: 'INCREASE' },
    { name: 'DECREASE', label: 'DECREASE', value: 'DECREASE' },
]